import { alertClasses, Alert as MuiAlert, Stack, styled, TableContainer } from '@mui/material';

export const StyledAlert = styled(MuiAlert)(({ theme }) => ({
  borderColor: theme.palette.custom.OV.sys.outlineVariant,
  backgroundColor: theme.palette.custom.OV.sys.surface,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  [`.${alertClasses.icon}`]: {
    color: theme.palette.custom.OV.sys.secondary,
  },
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: theme.spacing(1),
}));

export const StyledRoundedBox = styled(Stack)(({ theme }) => ({
  borderColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));
